<script>
  // Shown when a microfrontend bundle cannot be loaded from its container.
  import {
    faTriangleExclamation,
    faRotateRight,
  } from "@fortawesome/pro-solid-svg-icons";
  import { Callout, Text, Icon, Button } from "@gl/design-system";
  import { _ } from "../stores/index";

  /** i18n key of the microfrontend, e.g. "cut-manager". */
  export let app;
  /** True while a retry is in flight, so the button shows its loading state. */
  export let retrying = false;
</script>

<Callout status="error" iconBefore={faTriangleExclamation}>
  <div class="mfe-error">
    <div>
      <Text>
        <b>{$_("microfrontend.error.title", { values: { app: $_(app) } })}</b>
      </Text>
      <Text class="level-6">{$_("microfrontend.error.hint")}</Text>
    </div>
    <Button status="error" outlined size="small" loading={retrying} on:click>
      <Icon icon={faRotateRight} class="mr-2" />
      {$_("microfrontend.error.retry")}
    </Button>
  </div>
</Callout>

<style>
  .mfe-error {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
</style>
